import { NgModule } from 'ng-metadata/core';
import {PrmAuthoritySearch} from "./authoritySearch.directive";
import { AuthoritySearchService } from './authoritySearch.service';
import { PrmAuthoritySearchBar } from './authoritySearchBar/authoritySearchBar.directive';
import { AuthoritySearchBarService } from './authoritySearchBar/authoritySearchBar.service';

@NgModule({
    declarations: [ PrmAuthoritySearch,
                    PrmAuthoritySearchBar
                   ],
    providers: [  
        AuthoritySearchService,
        AuthoritySearchBarService
          ],
    imports:[
    ]
})
export class AuthoritySearchModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/authority/authoritySearch.module.ts